<template>
    <div class="question-form-wrapper scroll-tracker">
        <div class="question-info">
            <div class="form-label required">
                {{ classLabel }}
            </div>
            <Select
                class="class-selector"
                @selectClick="selectClick"
                :disabled="disabledSceneId"
                :initValue="initSceneId"
                :topOrBottom="86"
                :options="sceneClass"
                @menuClick="sceneSelected"
            >
                <Search :placeholder="palceHolder" @searchChange="searchChange" @inputChange="searchChange" class="scene-search" />
            </Select>
            <div class="form-label required">
                {{ standQuesLabel }}
                <em class="gray-label" v-if="!!curQuestionId">({{ curQuestionId }})</em>
            </div>
            <input
                :placeholder="standPlaceHolder"
                v-model="standQuestion"
                type="text"
                class="form-input"
                @input="inputChange()"
                @blur="autoFillTip"
            />

            <div class="form-label required">
                {{ optionTipLabel }}
            </div>
            <input :placeholder="optionPlaceHolder" v-model="optionTip" type="text" class="form-input" @input="inputChange" />
        </div>
        <div class="similar-edit form-label">
            <div class="similar-edit-lablel">
                <div class="similar-edit-text" :title="similarLabel">{{ similarLabel }}</div>
                <em class="gray-label">({{ similarCount }})</em>
            </div>
            <RoundButton class="similar-edit-btn" :class="{ on: curPanel == 'SimilarPanel' }" :text="similarBtnLabel" @btnClick="similarClick" />
        </div>

        <div class="form-label answer-label">
            {{ answerLabel }}
        </div>
        <div class="answer-list scroll-tracker">
            <div class="answer-item" v-for="(answer, idx) in answerList" :key="idx" v-show="answer.updateState != 'delete'">
                <RoundButton
                    class="answer-item-btn"
                    :class="{ on: answer == currentAnswer }"
                    :text="answer.name"
                    @btnClick="switchAnswer(answer, idx)"
                />
                <i class="answer-item-delete" @click="deleteAnswer(answer)"></i>
            </div>
            <div class="answer-item answer-add">
                <RoundButton class="answer-item-btn" :icon="addIcon" @btnClick="addAnswer" />
            </div>
        </div>
    </div>
</template>

<script>
import Select from "@/views/zhiji/bComponents/inputs/Select";
import Search from "@/views/zhiji/bComponents/inputs/Search";
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import i18n from "@/i18n";

export default {
    name: "LeftQuestionForm",
    components: {
        Select,
        RoundButton,
        Search
    },
    props: ["curPanel", "default"],
    data() {
        return {
            standQuestion: "",
            optionTip: "",
            currentAnswerUid: ""
        };
    },
    watch: {
        questionInfo() {
            this.initInputs();
        }
    },
    computed: {
        classLabel() {
            return this.$t("zhiji.knowlege.quesEditModal.categoriy");
        },
        standQuesLabel() {
            return this.$t("zhiji.knowlege.quesEditModal.standQues");
        },
        standPlaceHolder() {
            return this.$t("zhiji.knowlege.quesEditModal.inputStand");
        },
        optionTipLabel() {
            return this.$t("zhiji.knowlege.quesEditModal.shortbarTip");
        },
        optionPlaceHolder() {
            return this.$t("zhiji.knowlege.quesEditModal.enterShortBarTip");
        },
        similarLabel() {
            return this.$t("zhiji.knowlege.quesEditModal.simliarQues");
        },
        palceHolder() {
            return this.$t("zhiji.knowlege.sceneSearch");
        },
        answerLabel() {
            return this.$t("zhiji.common.answer");
        },
        similarBtnLabel() {
            return this.$t("zhiji.common.edit");
        },
        sceneClass() {
            let scenes = this.getStorePorp("sceneClassDatas").slice(0) || [];

            // 添加默认状态
            scenes.unshift({
                label: this.$t("zhiji.knowlege.quesEditModal.selectScene"),
                value: "def"
            });

            return scenes;
        },
        initSceneId() {
            const questionInfo = this.questionInfo;
            return "" + questionInfo.sceneClassId;
        },
        curQuestionId() {
            const questionInfo = this.questionInfo;
            return questionInfo.questionId;
        },
        questionInfo() {
            return this.getStorePorp("questionInfo");
        },
        addIcon() {
            return "url(" + this.zhiji.staticPath() + "class-spr.png) -296px 1px";
        },
        answerList() {
            return this.getStorePorp("answers") || [];
        },
        similarCount() {
            return this.getStorePorp("totalSimilar");
        },
        currentAnswer() {
            return this.getStorePorp("currentAnswer");
        },
        disabledSceneId() {
            return !this.isDefaultLang(this.getStorePorp("currentSynonym"));
        },
        defaultLang() {
            const defaultLang = this.$store.state.zhiji.gameState.defaultLang;
            return defaultLang ? defaultLang : "en";
        }
    },
    mounted() {
        this.initInputs();
    },
    methods: {
        initInputs() {
            let qInfo = this.questionInfo;
            this.standQuestion = this.default || qInfo.standQuestion;
            this.optionTip = this.default || qInfo.optionTip;
            this.inputChange(true);
        },
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionEdit[propName];
        },
        sceneSelected(sceneClass) {
            this.$store.commit("zhiji/updateEditQsForm", {
                sceneClassId: sceneClass.value
            });
            let data = this.getStorePorp("questionInfo");
            let currentAnswer = this.getStorePorp("currentAnswer");
            !data.questionId &&
                this.zhiji
                    .requestByServiceName("getRecommendShortbar", {
                        sceneId: data.sceneClassId,
                        questionId: data.questionId,
                        lang: this.getStorePorp("currentSynonym")
                    })
                    .then(result => {
                        this.$store.commit("zhiji/updateEditQsForm", {
                            recommendOptions: result
                        });
                        currentAnswer != null &&
                            this.currentAnswerUid == currentAnswer.uId &&
                            this.$store.commit("zhiji/editQsUpdateAnswer", {
                                type: "addOption",
                                recommend: true,
                                options: result
                            });
                    });
        },
        similarClick() {
            this.$emit("similarEdit");
        },
        switchAnswer(answer, answerIdx) {
            // 只有第一个答案没有配置浮动框的时候，需要推荐浮动框
            if (answerIdx == 0 && !answer.options.length) {
                this.currentAnswerUid = answer.uId;
                answer.options = this.getStorePorp("recommendOptions");
            }
            this.$emit("switchAnswer");
            this.$store.commit("zhiji/editQsSelectAnswer", answer);
        },
        addAnswer() {
            this.$store.commit("zhiji/editQsaddAnswer");
        },
        selectClick() {
            this.$store.commit("zhiji/searchScenes", {
                field: ""
            });
        },
        inputChange(noChange) {
            this.$nextTick(() => {
                this.$store.commit("zhiji/updateEditQsForm", {
                    standQuestion: this.standQuestion,
                    optionTip: this.optionTip || this.standQuestion,
                    noChange
                });
            });
        },
        autoFillTip() {
            !this.optionTip && (this.optionTip = this.standQuestion);
        },
        searchReferenceSimilars() {
            this.$store.dispatch("zhiji/searchReferenceSimilars", {
                keywords: this.standQuestion
            });
        },
        deleteAnswer(answer) {
            this.$store.commit("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: i18n.t("zhiji.knowlege.quesEditModal.delAnswerTip"),
                    confirm: () => {
                        this.$store.commit("zhiji/editQsDeleteAnswer", {
                            uId: answer.uId
                        });
                    }
                }
            });
        },
        searchChange(data) {
            this.$store.commit("zhiji/searchScenes", {
                field: data.value
            });
        },
        isDefaultLang(lang) {
            return this.defaultLang == lang;
        }
    }
};
</script>

<style lang="scss" scoped>
.question-form-wrapper {
    position: relative;
    width: 272px;
    padding: 0 18px 16px;
    font-size: 14px;
    border-right: 1px solid #d8e4f0;
    background: #f2f7fb;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    .form-label {
        margin: 20px 0 5px 0;
        font-weight: bold;

        .gray-label {
            color: #9b9ba3;
        }
        &:first-child {
            margin-top: 10px;
        }
    }

    .required {
        &:before {
            color: #fe0931;
            content: "*";
            display: inline-block;
        }
    }

    .form-input {
        border-radius: 4px;
        padding: 7px 8px;
        background: #fff;
        width: 100%;
        border: solid 1px #d8e4f0;
        box-sizing: border-box;
        color: #41475e;

        &:focus {
            border-color: #2088f3;
        }
    }

    .question-info {
        .class-selector {
            width: 235px;
            color: #9b9ba3;
        }

        .scene-search {
            width: 100%;
            position: absolute;
            left: 0;
            top: 42px;
            padding: 7px 0;
            background: #fff;
        }
    }

    .similar-edit {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .similar-edit-lablel {
        display: flex;
        overflow: hidden;
    }

    .similar-edit-text {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: default;
    }

    .similar-edit-btn {
        flex-grow: 0;
        flex-shrink: 0;
    }

    .similar-edit-btn,
    .answer-item-btn {
        position: relative;
        border: solid 1px #d8e4f0 !important;
        color: #41475e !important;
        background: #fff !important;
        box-shadow: none !important;
        box-sizing: border-box;
        line-height: 30px;
        width: 60px;
        min-width: 0;
        margin-right: 0px;

        &:hover,
        &.on {
            border-color: #9ba5cc !important;
            box-shadow: 2px 0 6px rgba(46, 98, 151, 0.2) !important;
            &:after {
                position: absolute;
                top: -2px;
                left: -2px;
                content: "";
                width: 100%;
                height: 100%;
                border: 2px solid #9ba5cc;
                border-radius: 20px;
            }
        }
    }

    .answer-list {
        padding: 5px 2px;
    }

    .answer-label {
        padding-top: 10px;
        border-top: 1px solid #d8e4f0;
    }

    .answer-item {
        margin-bottom: 8px;
        position: relative;

        &:hover {
            .answer-item-delete {
                display: inline-block;
            }
        }
    }

    .answer-item-delete {
        position: absolute;
        right: 0;
        top: -3px;
        width: 18px;
        height: 18px;
        background: url($zhijiStaticImagePath+"class-spr.png") -4px -1px;
        display: none;

        &:hover {
            background-position: -252px -20px;
        }
    }

    .answer-item-btn {
        width: calc(100% - 3px);
        padding: 11px 0;
        box-sizing: content-box;
        height: 16px;
        line-height: 1;
    }
}
</style>
